import { traceHandle } from '../tracing'
import { withGlobalOptions } from '../types'
import { addressHandles } from './address'
import { createCustomer } from './create'
import { fetchCustomer } from './fetch'
import { loginCustomer } from './login'
import { logoutCustomer } from './logout'
import { orderHandles } from './order'
import { recoverCustomer } from './recover'
import { refreshCustomer } from './refresh'

const customerAttributes = { 'shopify.api': 'storefront', 'shopify.operation': 'customer' } as const

export const customerHandles = withGlobalOptions({
  fetch: traceHandle('shopify.storefront.customer.query', customerAttributes, fetchCustomer),
  create: traceHandle('shopify.storefront.customer.mutate', customerAttributes, createCustomer),
  login: traceHandle('shopify.storefront.customer.mutate', customerAttributes, loginCustomer),
  refresh: traceHandle('shopify.storefront.customer.mutate', customerAttributes, refreshCustomer),
  logout: traceHandle('shopify.storefront.customer.mutate', customerAttributes, logoutCustomer),
  recover: traceHandle('shopify.storefront.customer.mutate', customerAttributes, recoverCustomer),
  address: addressHandles,
  order: orderHandles,
})
